// extracted by mini-css-extract-plugin
export default {"inputLabel":"activateModal_inputLabel__15H5z","inputWrapper":"activateModal_inputWrapper__NFxFc","form":"activateModal_form__8bMTX"};